import { createFeatureSelector, createSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import { Support } from './models/support.model';
import {
  ActionsEnum,
  FetchSupportSuccess,
  FetchSupportError,
} from './support-data.actions';

// feature name
export const FEATURE_NAME = 'support-data';

// state interface
export interface IState {
  support: Support;
  supportFetched: boolean;
  error: any[];
}

// initial state of store
export const initialState: IState = {
  support: null,
  supportFetched: false,
  error: null,
};

// reducer
const reducerFn = handleActions(
  {
    [ActionsEnum.FETCH_SUPPORT]: function (state: IState): IState {
      return {
        ...state,
        support: null,
        error: null,
        supportFetched: false,
      };
    },
    [ActionsEnum.FETCH_SUPPORT_SUCCESS]: function (
      state: IState,
      { payload }: FetchSupportSuccess
    ): IState {
      const { support } = payload;
      return {
        ...state,
        support,
        error: null,
        supportFetched: true,
      };
    },
    [ActionsEnum.FETCH_SUPPORT_ERROR]: function (
      state: IState,
      { payload }: FetchSupportError
    ): IState {
      const { error } = payload;

      return {
        ...state,
        support: null,
        error,
        supportFetched: true,
      };
    },
  } as any,
  initialState
);

// required for AOT
export function reducer(state: IState = initialState, action: any) {
  return reducerFn(state, action);
}

// selectors
const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export const getSupport = createSelector(
  selectFeature,
  (state: IState) => state.support
);
export const getSupportFetched = createSelector(
  selectFeature,
  (state: IState) => state.supportFetched
);
export const getError = createSelector(
  selectFeature,
  (state: IState) => state.error
);
